if (!customElements.get('quick-add-view')) {
  class QuickAddView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleButton = this.querySelector(':scope > .js-quick-add-toggle');
      if (!this.toggleButton) return;

      const variantsWrapperId = this.toggleButton.getAttribute('aria-controls');
      this.variantsWrapper = this.querySelector('#' + variantsWrapperId);
      if (!this.variantsWrapper) {
        this.variantsWrapper = document.getElementById(variantsWrapperId);
      }

      this.variantsWrapper.hidden = true;
      this.toggleButton.setAttribute('aria-expanded', 'false');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.toggleButton.addEventListener('click', this.handleToggle.bind(this));
    }

    handleToggle() {
      if (this.variantsWrapper.hidden) {
        this.showVariants();
      } else {
        this.hideVariants();
      }
    }

    showVariants() {
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.variantsWrapper.hidden = false;
    }

    hideVariants() {
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.variantsWrapper.hidden = true;
    }
  }

  customElements.define('quick-add-view', QuickAddView);
}
